import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import customFetch from "../../util/config/axiosConfig";
import { toast } from "sonner";

// Define the type for the file upload state
interface FilesState {
  uploadUrl: string;
  isUploadLoading: boolean;
}

// Define the type for the response from the API
interface UploadFileResponse {
  image_url: string;
}

// Initial state type
const initialState: FilesState = {
  uploadUrl: "",
  isUploadLoading: false,
};

// Create the async thunk for uploading a file
export const uploadFile = createAsyncThunk<
  UploadFileResponse, // The type of the data returned from the API
  File, // The type of the argument passed to the thunk
  { rejectValue: string } // The type of the value when the promise is rejected
>("file/uploadfile", async (file: File, thunkAPI) => {
  let accessToken = null;

  if (!accessToken) {
    accessToken =
      "eyJhbGciOiJIUzM4NCJ9.eyJzdWIiOiJzdHJpbmdAc3RyaW5nLmNvbSIsImlhdCI6MTczNTU4NDk0OCwiZXhwIjoxNzM2MTg5NzQ4fQ.1IFJBmQ_1Ja-_jfNV2lJ29afasCON70UjRIYQgHPI60MIUG4brzIEeD9LE5EqJ7t";
  }

  try {
    console.log(file);

    // Use FormData to correctly format the file upload payload
    const formData = new FormData();
    formData.append("file", file);

    const resp = await customFetch.post("api/file/upload", formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "multipart/form-data", // Set content type for file upload
      },
    });

    return resp?.data;
  } catch (error) {
    return thunkAPI.rejectWithValue("Unknown error");
  }
});

// Define the slice
const FilesSlice = createSlice({
  name: "file",
  initialState,
  reducers: {
    setUploadLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isUploadLoading = payload;
    },
    clearFile: (state) => {
      state.uploadUrl = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadFile.fulfilled, (state, { payload }) => {
        state.isUploadLoading = false;
        state.uploadUrl = payload.image_url;
        toast.success("File uploaded successfully");
      })
      .addCase(uploadFile.pending, (state) => {
        state.isUploadLoading = true;
      })
      .addCase(uploadFile.rejected, (state, { payload }) => {
        alert(payload || "Error while uploading!");
        state.isUploadLoading = false;
      });
  },
});

// Export actions and reducer

export default FilesSlice.reducer;
export const { setUploadLoading, clearFile } = FilesSlice.actions;
